import { useRef, useState, useEffect, useImperativeHandle, forwardRef } from "react";
import "./styles.css";

const UploadComponent = forwardRef(function UploadComponent({ onChange = () => {} }, ref) {
  const fileInputRef = useRef();
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const handlePaste = (event) => {
      const items = event.clipboardData?.items;
      if (!items) return;

      const pastedFiles = [];
      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) {
            pastedFiles.push(file);
          }
        }
      }

      if (pastedFiles.length > 0) {
        addFiles(pastedFiles);
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => {
      window.removeEventListener("paste", handlePaste);
    };
  }, [files]);


  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.target.classList.remove("drag-over");
    if (e.dataTransfer.files.length > 0) {
      addFiles(e.dataTransfer.files);
    }
  };

  const addFiles = (newFiles) => {
    const updated = [...files, ...Array.from(newFiles)];
    setFiles(updated);
    onChange(updated);
  };

  const removeFile = (index) => {
    const updated = files.filter((_, i) => i !== index);
    setFiles(updated);
    onChange(updated);
  };

  const clearAll = () => {
    setFiles([]);
    onChange([]);
  };

    useImperativeHandle(ref, () => ({
    clearAll: () => {
      setFiles([]);
      onChange([]); // notifica o pai, se necessário
    }
  }));

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const getFileIcon = (type) => {
    if (type.startsWith("image/")) return "fa-image";
    if (type.startsWith("video/")) return "fa-video";
    if (type.startsWith("audio/")) return "fa-music";
    if (type.includes("pdf")) return "fa-file-pdf";
    if (type.includes("word")) return "fa-file-word";
    if (type.includes("excel")) return "fa-file-excel";
    if (type.includes("zip")) return "fa-file-archive";
    return "fa-file";
  };

  return (

    <div className="bg-white rounded-xl  overflow-hidden">

      <div
        className="upload-container border-2 border-dashed border-gray-200 rounded-lg p-8 text-center cursor-pointer hover:border-indigo-400"
        onClick={() => fileInputRef.current.click()}
        onDragOver={(e) => {
          e.preventDefault();
          e.currentTarget.classList.add("drag-over");
        }}
        onDragLeave={(e) => e.currentTarget.classList.remove("drag-over")}
        onDrop={handleDrop}
      >
        <div className="max-w-md mx-auto text-sm ">
          <i className="fas fa-file-upload text-4xl text-indigo-500 mb-2"></i>
          <h3 className="text-sm font-medium text-gray-800 mb-1">Solte arquivos aqui</h3>
          <p className="text-gray-500 mb-2">ou clique para navegar no seu dispositivo</p>
          <input
            type="file"
            className="hidden"
            multiple
            ref={fileInputRef}
            onChange={(e) => addFiles(e.target.files)}
          />
          <button type="button" className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-md font-medium">
            Escolher arquivos
          </button>
        </div>
      </div>

      {files.length > 0 && (
        <div className="mt-6 space-y-3">
          <div className="flex items-center justify-between bg-gray-50 px-4 py-1 rounded-md">
            <div className="flex items-center space-x-2">
              <span className="text-gray-500">Arquivos selecionados:</span>
              <span className="font-medium">{files.length}</span>
            </div>
            <button onClick={clearAll} className="text-red-500 hover:text-red-700 text-sm font-medium">
              Limpar todos arquivos
            </button>
          </div>

          <div className="space-y-2 max-h-64 overflow-y-auto pr-2">
            {files.map((file, index) => (
              <div
                key={index}
                className="file-item bg-white border border-gray-200 rounded-lg p-3 flex items-center justify-between"
              >
                <div className="flex items-center space-x-3">
                  <i className={`fas ${getFileIcon(file.type)} text-indigo-500`}></i>
                  <div>
                    <div className="font-medium text-gray-800 truncate" title={file.name}>
                      {file.name}
                    </div>
                    <div className="text-xs text-gray-500">{formatFileSize(file.size)}</div>
                  </div>
                </div>
                <button onClick={() => removeFile(index)} className="text-red-500 hover:text-red-700">
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>

  );
}
  );
export default UploadComponent;